// notification/notification-preference.schema.ts
import { z } from "zod";
var NOTIFICATION_EVENT_TYPES = ["order_partition.created"];
var NotificationEventTypeSchema = z.enum(NOTIFICATION_EVENT_TYPES);
var NOTIFICATION_CHANNELS = ["email", "sms"];
var NotificationChannelSchema = z.enum(NOTIFICATION_CHANNELS);
var MemberNotificationPreferenceSchema = z.object({
  id: z.string().uuid(),
  memberId: z.string().uuid(),
  eventType: NotificationEventTypeSchema,
  channel: NotificationChannelSchema,
  isEnabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var MemberNotificationPreferenceDtoSchema = z.object({
  id: z.string().uuid(),
  memberId: z.string().uuid(),
  eventType: NotificationEventTypeSchema,
  channel: NotificationChannelSchema,
  isEnabled: z.boolean()
});
var UpdateNotificationPreferenceInputSchema = z.object({
  eventType: NotificationEventTypeSchema,
  channel: NotificationChannelSchema,
  isEnabled: z.boolean()
});
var BulkUpdateNotificationPreferencesInputSchema = z.object({
  preferences: z.array(UpdateNotificationPreferenceInputSchema)
});
var PreferencesResultSchema = z.object({
  preferences: z.array(MemberNotificationPreferenceDtoSchema),
  hasPhone: z.boolean()
});
export {
  BulkUpdateNotificationPreferencesInputSchema,
  MemberNotificationPreferenceDtoSchema,
  MemberNotificationPreferenceSchema,
  NOTIFICATION_CHANNELS,
  NOTIFICATION_EVENT_TYPES,
  NotificationChannelSchema,
  NotificationEventTypeSchema,
  PreferencesResultSchema,
  UpdateNotificationPreferenceInputSchema
};
